import { useCallback, useEffect, useMemo } from "react"

import { useField, useFormikContext } from "formik"

import { PropTypes } from "@l2r-front/l2r-proptypes"

import * as Styled from "./FileNameTextField.styled"

export const FileNameTextField = (props) => {
    const {
        maxLength,
        value,
        onChange,
        ...otherProps
    } = props

    const [fieldProps, metaProps] = useField(props)
    const { setStatus } = useFormikContext()

    useEffect(() => {
        if (value?.length > maxLength) {
            const parts = value?.split(".")
            const extension = parts.length > 1 ? parts.pop() : ""
            const name = parts.join(".").substring(0, maxLength - (extension ? extension.length + 1 : 0))

            onChange(`${name}${extension ? "." + extension : ""}`)
        }
    }, [maxLength, value, onChange])

    const fileInfo = useMemo(() => {
        const parts = value?.split(".")
        const extension = parts.length > 1 ? parts.pop() : ""
        const name = parts.join(".").substring(0, maxLength - (extension ? extension.length + 1 : 0))

        return {
            name: name,
            extension: extension || "",
        }
    }, [maxLength, value])

    const handleChange = useCallback((event) => {
        fieldProps.onChange(event)
        const newValue = event.target.value
        onChange(`${newValue}${fileInfo.extension ? "." + fileInfo.extension : ""}`)
        setStatus()
    }, [fieldProps, setStatus, onChange, fileInfo])

    const handleBlur = useCallback((event) => {
        fieldProps.onBlur(event)
        props.onBlur?.(event)
    }, [fieldProps, props])

    return <Styled.TextField
        {...props}
        {...fieldProps}
        {...((metaProps.error && metaProps.touched) ? {
            error: true,
            helperText: metaProps.error,
        } : {})}
        onBlur={handleBlur}
        hasSeparator={!!fileInfo.extension}
        value={fileInfo.name || ""}
        onChange={handleChange}
        InputProps={{
            endAdornment: (
                fileInfo.extension.length ? <Styled.ExtensionAdornment variant="Regular">{fileInfo.extension}</Styled.ExtensionAdornment> : undefined
            ),
        }}
        inputProps={{
            maxLength: maxLength - fileInfo.extension?.length,
        }}
        {...otherProps}
    />
}

FileNameTextField.propTypes = {
    maxLength: PropTypes.number,
    value: PropTypes.string,
    onChange: PropTypes.func.isRequired,
}

FileNameTextField.defaultProps = {
    maxLength: 100,
}